import { RelationCardinality } from "../contracts/base";

enum Cardinality {
    OneToOne,
    OneToMany,
    ManyToMany,
}

export class MinimalSchemaRelationCardinalityConverter {
    serialize(value: RelationCardinality): Cardinality {
        switch (value) {
            case RelationCardinality.ManyToMany:
                return Cardinality.ManyToMany;
            case RelationCardinality.OneToMany:
                return Cardinality.OneToMany;
            case RelationCardinality.OneToOne:
                return Cardinality.OneToOne;
        }
    }

    deserialize(value: Cardinality): RelationCardinality {
        switch (value) {
            case Cardinality.ManyToMany:
                return RelationCardinality.ManyToMany;
            case Cardinality.OneToMany:
                return RelationCardinality.OneToMany;
            case Cardinality.OneToOne:
                return RelationCardinality.OneToOne;
        }
    }
}
